import {
  AVAILABLE_SUBDOMAINS,
  AvailableSubdomain,
  appUrlFormat,
} from "@/env/config";

function toPath(subdomain: AvailableSubdomain): string {
  return `/${subdomain}`;
}

/**
 * pathnameがsubdomainのパスから始まっていたら true を返す
 */
function isStartsWithSubdomain(
  subdomain: AvailableSubdomain,
  pathname: string,
): boolean {
  const sub = toPath(subdomain);
  return pathname.startsWith(sub);
}

/**
 * pathnameの先頭からsubdomainのパスを削除し、新しいpathnameを返す
 */
function removeSubdomain(
  subdomain: AvailableSubdomain,
  pathname: string,
): string {
  const sub = toPath(subdomain);
  const regexp = new RegExp(`^${sub}`);
  return pathname.replace(regexp, "");
}

function convertUrl(subdomain: AvailableSubdomain, pathname: string): string {
  const newPathname = removeSubdomain(subdomain, pathname);
  return appUrlFormat(subdomain, newPathname);
}

/**
 * pathnameがサブドメインのパスから始まっていたら、サブドメインを含むURLに書き換える
 *
 * pagesPath, routePathのpathは最初からこれが掛かったものを返すので掛ける必要はない（この関数は冪等なので掛けても問題はない）
 */
export function appUrl(pathname: string): string {
  for (const subdomain of AVAILABLE_SUBDOMAINS) {
    if (isStartsWithSubdomain(subdomain, pathname)) {
      return convertUrl(subdomain, pathname);
    }
  }
  return pathname;
}

/** @knipignore */
export const forTest = {
  toPath,
  isStartsWithSubdomain,
  removeSubdomain,
  convertUrl,
};
